import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TenantBidShipment from './tenant-bid-shipment';
import TenantBidShipmentDetail from './tenant-bid-shipment-detail';
import TenantBidShipmentUpdate from './tenant-bid-shipment-update';
import TenantBidShipmentDeleteDialog from './tenant-bid-shipment-delete-dialog';

const TenantBidShipmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TenantBidShipment />} />
    <Route path="new" element={<TenantBidShipmentUpdate />} />
    <Route path=":id">
      <Route index element={<TenantBidShipmentDetail />} />
      <Route path="edit" element={<TenantBidShipmentUpdate />} />
      <Route path="delete" element={<TenantBidShipmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TenantBidShipmentRoutes;
